import { Component } from "react";
import { extract } from "@parksandresorts/core";
import styles from "./loader.module.less";

export default class Loader extends Component {
  constructor(props) {
    super(props);

    this.loadingText = extract(props, "loadingText");
    this.className = extract(props, "className");
  }

  render() {
    return (
      <div className="block--max-width-narrow">
        <div className={this.className ? this.className : ""}>
          <div className={[styles.loadingWrapper].join(" ")}>
            <div className={styles.loaderIcon}>
              <svg
                style={{ shapeRendering: "auto" }}
                width="100%"
                height="100%"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <path
                  fill="none"
                  stroke="#FFF"
                  strokeWidth="6"
                  strokeDasharray="161.65102478027345 94.9379034423828"
                  d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z"
                  strokeLinecap="round"
                  style={{ transform: "scale(0.6900000000000001)", transformOrigin: "50px 50px" }}
                >
                  <animate
                    attributeName="stroke-dashoffset"
                    repeatCount="indefinite"
                    dur="2.1739130434782608s"
                    keyTimes="0;1"
                    values="0;256.58892822265625"
                  ></animate>
                </path>
              </svg>
            </div>
            {this.loadingText && <h3 className={styles.loadingText}>{this.loadingText}</h3>}
          </div>
        </div>
      </div>
    );
  }
}
